import { render, staticRenderFns } from "./CustomizeFormInfo.vue?vue&type=template&id=1cf54e6f&scoped=true"
import script from "./CustomizeFormInfo.vue?vue&type=script&lang=js"
export * from "./CustomizeFormInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomizeFormInfo.vue?vue&type=style&index=0&id=1cf54e6f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf54e6f",
  null
  
)

export default component.exports